
import React, { useEffect, useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function SubscriptionPage() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
const [invoiceUrl, setInvoiceUrl] = useState("");
const [invoiceId, setInvoiceId] = useState("");

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const res = await API.post("/plans/");
      setPlans(res.data);
    } catch (error) {
      console.error("Failed to fetch plans", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBuy = async (plan) => {
  const token = localStorage.getItem("token");

  if (!token) {
    alert("Please login first");
    navigate("/login");
    return;
  }

  try {
    const res = await API.post("/create-order", {
      plan: plan.name,
    });

    const { order_id, amount, key } = res.data;

    const options = {
      key,
      amount,
      currency: "INR",
      name: "CarePlus",
      description: `${plan.name} Plan`,
      order_id,

      handler: async function (response) {
        try {
          const verifyRes = await API.post(
            "/verify-payment",
            {
              ...response,
              plan: plan.name,
            }
          );

          setInvoiceId(
            verifyRes.data.invoice_id || ""
          );

          setInvoiceUrl(
            verifyRes.data.invoice_url || ""
          );

          setShowInvoiceModal(true);

        } catch (err) {
          console.error(err);
          alert(
            "Payment verification failed"
          );
        }
      },

      prefill: {
        name: "CarePlus User",
      },

      theme: {
        color: "#2563eb",
      },
    };

    const razorpay =
      new window.Razorpay(options);

    razorpay.open();

  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
};

const handleDownloadInvoice = async () => {
  try {
    const response = await fetch(invoiceUrl);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "invoice.pdf";

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
  }
};

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <Navbar />

      <div className="pt-24 pb-16 px-4 flex flex-col items-center">
        {/* HEADER */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-blue-700 mb-2">
            Subscription Plans
          </h1>
          <p className="text-gray-600 text-lg">
            Simple pricing. Powerful features.
          </p>
        </div>

        {/* LOADING */}
        {loading ? (
          <p className="text-gray-500 text-lg">Loading plans...</p>
        ) : (
          <div className="flex flex-wrap justify-center gap-8 w-full max-w-6xl">
            {plans.map((plan) => {
              const pricePerCredit = (plan.price / plan.credits).toFixed(0);

              const features = [
                "AICA E-Rx: Smart Digital Prescription",
                "💊 1 Credit = 1 Prescription",
                "🧑 1 Credit = 1 Patient Usage",
                "📩 SMS",
                "✔ GST Included",
              ];

              return (
                <div
                  key={plan.id}
                  className={`relative w-80 bg-white rounded-2xl shadow-xl border p-8 transition transform hover:-translate-y-2 hover:shadow-2xl 
                  ${
                    plan.is_popular
                      ? "border-2 border-blue-600 scale-105"
                      : "border-blue-100"
                  }`}
                >
                  {/* Badge */}
                  {plan.is_popular && (
                    <span className="absolute -top-3 right-4 bg-blue-600 text-white text-xs px-3 py-1 rounded-full shadow">
                      Most Popular
                    </span>
                  )}

                  {/* Plan Name */}
                  <h2 className="text-xl font-bold text-blue-700 text-center">
                    {plan.name.toUpperCase()}
                  </h2>

                  {/* Price */}
                  <div className="text-center mt-4">
                    <div className="flex justify-center items-end gap-1">
                      <span className="text-lg text-gray-400">₹</span>
                      <span className="text-5xl font-extrabold text-blue-600">
                        {plan.price}
                      </span>
                    </div>

                    <p className="text-sm text-gray-500 mt-2">
                      ₹{pricePerCredit} per Credit
                    </p>
                  </div>

                  {/* Credits Info */}
                  <div className="text-center mt-5 space-y-2">
                    <p className="text-lg font-semibold text-blue-600">
                      💊 {plan.credits} Prescription Credits
                    </p>

                    <p className="text-sm font-medium text-indigo-600">
                      🧑 {plan.patient_credits} Patient Credits
                    </p>

                    <p className="text-xs text-gray-500">
                      1 Credit = 1 Prescription / Patient
                    </p>

                    <p className="text-sm text-green-600 font-semibold">
                      Total Actions:{" "}
                      {plan.credits + plan.patient_credits}
                    </p>
                  </div>

                  {/* Features */}
                  <ul className="mt-6 space-y-3 text-gray-700 text-sm">
                    {features.map((item, index) => (
                      <li key={index} className="flex items-center gap-2">
                        <span className="text-green-500">✔</span>
                        {item}
                      </li>
                    ))}
                  </ul>

                  {/* Button */}
                  <button
                    onClick={() => handleBuy(plan)}
                    className={`w-full mt-6 py-3 rounded-lg font-semibold transition-all duration-200 
                    ${
                      plan.is_popular
                        ? "bg-blue-600 text-white hover:bg-blue-700"
                        : "bg-blue-100 text-blue-800 hover:bg-blue-200"
                    }`}
                  >
                    Buy Now
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {showInvoiceModal && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center">

    {/* Background */}
    <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

    {/* Modal */}
    <div className="relative bg-white rounded-3xl shadow-2xl p-8 w-[95%] max-w-md">

      <div className="text-center">

        <div className="w-24 h-24 mx-auto rounded-full bg-green-100 flex items-center justify-center text-5xl mb-5">
          🎉
        </div>

        <h2 className="text-3xl font-bold text-green-600 mb-2">
          Payment Successful
        </h2>

        <p className="text-gray-500">
          Your subscription has been activated successfully.
        </p>

        {invoiceId && (
          <div className="mt-5 bg-gray-50 rounded-xl p-4 border">

            <p className="text-xs text-gray-500">
              Invoice ID
            </p>

            <p className="font-semibold break-all">
              {invoiceId}
            </p>

          </div>
        )}

        <div className="mt-6 space-y-3">

          {invoiceUrl && (
            <>
              <a
                href={invoiceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold"
              >
                  📄 View / Download Invoice
              </a>
            </>
          )}

          <button
            onClick={() => {
              setShowInvoiceModal(false);
              navigate("/doctor-dashboard");
            }}
            className="w-full py-3 rounded-xl bg-gray-100 hover:bg-gray-200 font-semibold"
          >
            Go To Dashboard
          </button>

        </div>

      </div>

    </div>

  </div>
)}
    </div>
  );
}

